<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="flex flex-col h-full w-full p-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col min-ht-78">
                    <div class="h-full flex justify-start items-center">
                        <div v-if="token" class="flex-shrink-0 mr-4">
                            <icon-back @click.stop="goBackTo('/virtual-career-fair')"></icon-back>
                        </div>
                        <div class="flex-grow">
                            <div class="flex items-center text-sm font-light">
                                <router-link to="/dashboard"
                                    class="opacity-50 hover:opacity-100">Dashboard</router-link>
                                <span class="mx-2">/</span>
                                <router-link to="/virtual-career-fair" class="opacity-50 hover:opacity-100">Virtual
                                    Career
                                    Fair</router-link>
                                <span class="mx-2">/</span>
                                <span>Virtual Career Fair Registrations</span>
                            </div>
                            <div class="font-bold">{{ getTitle }}</div>
                        </div>
                    </div>
                </div>

                <section :class="hasItems ? 'mt-4' : 'mt-8'"
                    class="h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-between items-start flex-wrap">
                        <h1 class="text-base md:text-lg font-semibold mb-4">
                            {{ getSubTitle }}
                        </h1>
                    </div>
                    <div class="flex flex-col" v-if="$apollo.queries.virtualCareerFairRegistrations.loading">
                        <table-shimmer :titleHeaders="[
                            '#',
                            'Student',
                            'Entity',
                            'CV',
                            'Registered At',
                        ]" :rows="first"></table-shimmer>
                    </div>
                    <div v-else-if="!$apollo.queries.virtualCareerFairRegistrations.loading && !hasItems"
                        class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">
                            No Virtual Career Fair Registrations found!
                        </h1>
                    </div>
                    <div v-else class="flex flex-col -mt-4">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">
                                                    #
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Student
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Entity
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    CV
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Registered At
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in items" :key="index"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">
                                                    {{ paginatorInfo.firstItem + index }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div @click.stop="
                                                        viewStudentProfile(item.user.students.student_id)
                                                        " class="flex items-center cursor-pointer group">
                                                        <div class="flex-shrink-0 mr-3">
                                                            <img class="h-12 w-12 rounded-lg object-cover" :src="getProfilePicture(
                                                                item.user.profile_picture_url,
                                                                item.user.students.student_id,
                                                                item.user.students.entity
                                                            )
                                                                " alt="" />
                                                        </div>
                                                        <div class="flex-grow flex flex-col mr-4">
                                                            <h1 class="text-sm font-semibold flex items-center">
                                                                <span class="text-heading group-hover:text-blue-600">{{
                                                                    item.user.name }}</span>
                                                            </h1>
                                                            <p class="text-xs text-gray-400 group-hover:text-blue-400">
                                                                {{ item.user.students.student_id }}
                                                            </p>
                                                            <p class="text-xs text-gray-400 group-hover:text-blue-400">
                                                                {{ item.user.email }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    {{ getEntityName(item.user.students.entity) }}
                                                </td>
                                                <td class="px-6 py-2">
                                                    <a :href="getUrl(item.path)" target="_blank"
                                                        class="text-blue-600 hover:underline text-sm font-medium">
                                                        View CV
                                                    </a>
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    {{ getFormattedDateWithTimeAmPm(item.created_at) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>
                </section>

            </div>
        </div>

        <transition name="fade" mode="out-in">
            <base-full-modal v-if="showFullModal" title="Student Profile" @close="closeFullModal">
                <student-profile :student-id="studentId"></student-profile>
            </base-full-modal>
        </transition>

    </div>
</template>

<script>
import gql from "graphql-tag";
import Pagination from "../../components/shared/pagination.vue";
import TableShimmer from "../../components/shared/TableShimmer.vue";
import StudentProfile from "../student-profile/index.vue";
import IconBack from "../../components/icons/IconBack.vue";
import { formattedDateWithTimeAmPm } from "../../helpers/utils";
export default {
    name: "virtual-career-fair-registration",
    components: {
        IconBack,
        Pagination,
        TableShimmer,
        StudentProfile,
    },
    data() {
        return {
            virtualCareerFairRegistrations: [],
            first: 10,
            page: 1,
            showFullModal: false,
            studentId: null,
        };
    },
    props: ["token"],
    watch: {
        virtualCareerFairRegistrations(newVal) {
            if (newVal.error) {
                if (newVal.error_code == 403) {
                    this.$router.replace("/no-permission");
                } else if (newVal.error_code == 401) {
                    this.$router.replace("/");
                } else {
                    alert(newVal.message);
                    this.$router.replace("/");
                }
            }
        },
    },
    computed: {
        getTitle() {
            if (this.token) {
                return localStorage.getItem("virtualCareerFairRegistrationTitle");
            } else {
                return "Virtual Career Fair Registrations";
            }
        },
        getSubTitle() {
            if (this.token) {
                if (this.$apollo.queries.virtualCareerFairRegistrations.loading) {
                    return "";
                } else {
                    return `Virtual Career Fair Registrations List (${this.paginatorInfo.total})`;
                }
            } else {
                return "Event Registrations List";
            }
        },
        hasToken() {
            if (this.token !== undefined) {
                return true;
            } else {
                return false;
            }
        },
        items() {
            return this.virtualCareerFairRegistrations.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.virtualCareerFairRegistrations.paginatorInfo;
        },
    },
    apollo: {
        virtualCareerFairRegistrations() {
            return {
                query: gql`
                    query GetAllVirtualCareerFairRegistrations(
                        $first: Int!
                        $page: Int!
                        $token: String
                    ) {
                        virtualCareerFairRegistrations(
                            first: $first
                            page: $page
                            token: $token
                        ) {
                            error
                            error_code
                            message
                            data {
                                path
                                created_at
                                user {
                                    name
                                    email
                                    profile_picture_url
                                    students {
                                        student_id
                                        entity
                                    }
                                }
                            }
                            paginatorInfo {
                                count
                                currentPage
                                firstItem
                                hasMorePages
                                lastItem
                                lastPage
                                perPage
                                total
                            }
                        }
                    }
                `,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        token: this.token ? this.token : "",
                    };
                },
                fetchPolicy: "cache-and-network",
            };
        },
    },
    methods: {
        setPage(page) {
            this.page = page;
        },
        goBackTo(url) {
            this.$router.replace(url);
        },
        getEntityName(entity) {
            return entity.replace(/ATHS/g, "ATS");
        },
        viewStudentProfile(studentId) {
            this.studentId = studentId;
            this.showFullModal = true;
        },
        closeFullModal() {
            this.showFullModal = false;
            this.studentId = null;
        },
        getProfilePicture(profilePictureUrl, studentId, entity) {
            if (
                profilePictureUrl ==
                "/storage/alumni-profile-pictures/default-avatar.jpg"
            ) {
                return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
            } else {
                return process.env.VUE_APP_PUBLIC_URL + profilePictureUrl;
            }
        },
        getFormattedDateWithTimeAmPm(date) {
            return formattedDateWithTimeAmPm(date);
        },
        getUrl(url) {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
    },
}
</script>

<style lang="scss" scoped>
@responsive {
    .min-ht-78 {
        min-height: 78px;
    }
}
</style>